import type { ReactElement } from 'react';
import { Ctext } from '../Ctext';
import type { ChackerheaderTextVisualProps } from './ChackerheaderTypes';

interface ChackerheaderAnimatedTextProps extends ChackerheaderTextVisualProps {
  displayText: string;
  isAnimating: boolean;
}

export function ChackerheaderAnimatedText({
  displayText,
  fontSize,
  fontWeight,
  isAnimating,
  opacity,
  textColor,
}: ChackerheaderAnimatedTextProps): ReactElement {
  return (
    <Ctext
      color={textColor}
      opacity={opacity}
      size={fontSize}
      weight={fontWeight}
      style={{
        minWidth: '150px',
        textAlign: 'center',
      }}
    >
      {displayText}{isAnimating && '_'}
    </Ctext>
  );
}
